import { SVGProps, Ref, forwardRef } from 'react'
const SvgProtectPlan = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.25 3.924v7.614A11.907 11.907 0 0 0 9.882 22.65l1.041.4a3 3 0 0 0 2.154 0l1.041-.4a11.907 11.907 0 0 0 7.632-11.113V3.924a1.488 1.488 0 0 0-.868-1.362A21.7 21.7 0 0 0 12 .75a21.7 21.7 0 0 0-8.882 1.81 1.487 1.487 0 0 0-.868 1.363v0Z"
    />
    <path
      fill="currentColor"
      d="M8.528 10.896a.75.75 0 0 0-1.056 1.065l1.056-1.065ZM11.6 15l-.528.532a.75.75 0 0 0 1.122-.074L11.6 15Zm5.994-6.542a.75.75 0 1 0-1.188-.916l1.188.916ZM7.472 11.961l3.6 3.571 1.056-1.064-3.6-3.572-1.056 1.065Zm4.722 3.497 5.4-7-1.188-.916-5.4 7 1.188.916Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgProtectPlan)
export default ForwardRef
